export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑信息',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    disabled: ({ status }) => status != 'Y',
  },
  {
    text: that.$l('menu_text_delete') || '删除信息',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ status }) => status == 'N',
  },
]
